import { Store } from "vuex";
import { RootState } from "..";
import { namespace } from "../modules/ai/aiBrowse";
import { AiCacheSearchResultItem } from "@/types/ai/aiSearch";

export default class AiBrowse {
    private store: Store<RootState>;

    constructor(store: Store<RootState>) {
        this.store = store;
    }

    public async loadResultsAsync(portalId: number, collectionId: number | null): Promise<AiCacheSearchResultItem[]> {
        return this.store.dispatch(`${namespace}/loadResults`, { portalId, collectionId, itemsLoaded: null, disableCache: false });
    }

    public async loadMoreAsync(portalId: number, collectionId: number | null, itemsLoaded: number): Promise<AiCacheSearchResultItem[]> {
        return this.store.dispatch(`${namespace}/loadResults`, { portalId, collectionId, itemsLoaded, disableCache: true });
    }

    public getItemsToShow(portalId: number | null, collectionId: number | null): number {
        return this.store.getters[`${namespace}/getItemsToShow`](portalId, collectionId);
    }

    public setItemsToShow(portalId: number | null, collectionId: number | null, itemsToShow: number): void {
        this.store.commit(`${namespace}/setItemsToShow`, {
            portalId: portalId,
            collectionId: collectionId,
            itemsToShow: itemsToShow
        });
    }

    public areAllItemsLoaded(portalId: number | null, collectionId: number | null): boolean {
        return this.store.getters[`${namespace}/areAllItemsLoaded`](portalId, collectionId);
    }

    public getClientPageSize(): number {
        return this.store.getters[`${namespace}/getClientPageSize`];
    }

    public getCollectionIds(portalId: number | null, collectionId: number | null): number[] {
        return this.store.getters[`${namespace}/getCollectionIds`](portalId, collectionId);
    }
}
